export enum PaymentGateway {
    dummy = "50bc3a96-f317-4410-8bd5-3eb13ecead62",
    payUDomestic = "3239f506-d593-4017-8180-5065532412d7",
}
